import React from 'react';

const FooterHome = () => {
    return (
        <div style={{
            backgroundColor: '#172554',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#ffffff',
            fontSize: '1.2em',
        }}>
            <h2 style={{color: '#ffffff'}}>Contato</h2>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.8em',
                marginBottom: '-1em'
            }}>
                <i className="pi pi-phone" style={{ fontSize: '1.5rem' }}></i>
                <p>(34) 3822-9699</p>
            </div>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.8em'
            }}>
                <i className="pi pi-envelope" style={{ fontSize: '1.5rem' }}></i>
                <p onClick={() => window.location = "mailto:ceasa@patosdeminas.mg.gov.br"} style={{
                    cursor: 'pointer'
                }}>ceasa@patosdeminas.mg.gov.br</p>
            </div>
        </div>
    );
}

export default FooterHome;
